/**
 * @typedef {import('@/lib/classes/InfoWindowContent/DisplayField').DisplayField} DisplayField
 */

/**
 * Aggregation functions take blob data as an input and return some display field and delete function as output.
 * The display field will either be something that has one value, or it might have an array of sub display fields.
 * The delete function is returned to the caller so that the original blob will delete the keys that were used
 * to make the display field.
 * @callback AggregationFunction
 * @param {Object} blob
 * @returns {[DisplayField, Function]|[]}
 */

/**
 * @typedef {Object} Aggregator
 * @property {string} name
 * @property {AggregationFunction} function
 */

/**
 * Creates delete functions to be used by different aggregators
 * @param {Array<string>} deletionTargets keys represented as strings to delete
 * @return {createDeleteFunction} A function for deleting the keys
 */
function createDeleteFunction(deletionTargets) {
  /**
   * This function takes a blob, deletes targetted keys, and then returns the blob
   * @param {Object} blob an object with raw data
   * @return {Object} The blob without certain fields
   */
  return (blob) => {
    deletionTargets.forEach((target) => {
      delete blob[target];
    });
    return blob;
  };
}

export {
  createDeleteFunction,
};
